import Image from '../../Image/Image'
import { ArrowNavigationLeft, ArrowNavigationRight } from '../../SliderUtils/ArrowNavigation'
import { AssetType, ProductAssetImageType } from '../ProductAssets.types'
import { ProductVideo } from '../ProductVideo'
import useProductAssetsFullScreenSwiper from './useProductAssetsFullScreenSwiper'

const ProductAssetFullScreenImage = ({ image }: { image: ProductAssetImageType }) => (
  <div className='product-assets-fullscreen-image zoomable-image'>
    <Image src={image.src} alt={image.alt} width={600} height={600} />
  </div>
)

type ProductAssetsFullscreenCarouselProps = {
  assets: Array<AssetType>
  assetToPreview: AssetType
}

const ProductAssetsFullscreenCarousel = ({
  assets,
  assetToPreview,
}: ProductAssetsFullscreenCarouselProps) => {
  useProductAssetsFullScreenSwiper(assets, assetToPreview)

  return (
    <div className='product-assets-fullscreen-carousel'>
      <div className='product-assets-fullscreen-carousel-swiper'>
        <ul className='product-assets-fullscreen-carousel-list swiper-wrapper'>
          {assets.map((asset, i) => (
            <li
              key={asset.id}
              className='swiper-slide product-assets-fullscreen-carousel-item'
              data-swiper-slide-id={i}>
              {asset.type === 'image' ? (
                <ProductAssetFullScreenImage image={asset} />
              ) : (
                <ProductVideo video={asset} classname='product-assets-fullscreen-video' />
              )}
            </li>
          ))}
        </ul>
      </div>
      <ArrowNavigationLeft />
      <ArrowNavigationRight />
    </div>
  )
}

export default ProductAssetsFullscreenCarousel
